import {useStyles} from '@wix/tpa-settings/react'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import stylesParams from '../../../stylesParams'
import {useWidgetState} from '../../hooks/state-provider'
import {getEventBadge} from '../../selectors/events'
import {BadgeType, EVENT_BADGE_TYPE} from '../../utils/event-badges'
import s from './event-badge.scss'
import {EventBadgeProps} from './interfaces'

export const EventBadge = ({event, onImage, className}: EventBadgeProps) => {
  const {get} = useStyles()
  const {t} = useTranslation()

  const fullWidth = get(stylesParams.eventBadgeStretched)
  const eventBadge = useWidgetState(state => getEventBadge(state, event))
  const secondPriority = (eventBadge?.type as BadgeType) === EVENT_BADGE_TYPE.SECOND_PRIORITY
  const thirdPriority = (eventBadge?.type as BadgeType) === EVENT_BADGE_TYPE.THIRD_PRIORITY

  return eventBadge ? (
    <div
      className={classNames(className, onImage ? s.onImage : s.eventInfo, {
        [s.container]: onImage,
        [s.second]: secondPriority,
        [s.third]: thirdPriority,
      })}
    >
      <div
        data-hook="event-badge"
        className={classNames(s.badge, {
          [s.second]: secondPriority,
          [s.third]: thirdPriority,
          [s.fullWidth]: onImage && fullWidth,
        })}
      >
        <div className={classNames(s.text, {[s.second]: secondPriority, [s.third]: thirdPriority})}>
          {eventBadge.text ?? t('defaultEventBadge')}
        </div>
      </div>
    </div>
  ) : null
}
